<div class="input">
  <span [ngClass]="isValid?'input-calendar-name':'invalid-input-name'">{{name}}@if (required) {
    <span class="required"
    >*</span>
  }</span>
  @if (startingPlaceholder) {
    <div class="input-starting-placeholder">{{startingPlaceholder}}</div>
  }
  <div class="position-wrapper">
    @if (withImage) {
      <img src="../../../../content/images/calendar.png" class="input-image-calendar" (click)="picker.open()">
    }
    <input matInput [matDatepicker]="picker" (click)="picker.open()"
      title="{{this.isValidMessage}}"  spellcheck="false" (focus)="onSaveState()" [(ngModel)]="dateTimeRange"
      placeholder="{{placeholder}}"  class="input-component" (input)="onInputCheckEmpty($event)"
      (keydown.backspace)="onInputCheckEmpty($event)" [ngClass]="isValid?'input-component':'invalid-input-component'"
      [disabled]="!!disabled" (dateChange)="onChange();onSaveModel();"
    [min]="minDate" [max]="maxDate" readonly="{{clickOnly}}" [attr.data-testid]="testId">
    <mat-datepicker #picker ></mat-datepicker>
  </div>
</div>
